const HTMLElementBase = globalThis.HTMLElement ?? class {};

export function isElementPaintVisible(element) {
    return typeof element?.getClientRects !== "function"
        || element.getClientRects().length > 0;
}

/**
 * Paint-only base class for calculator presenters.
 *
 * Owners assign the complete, validated presentation DTO through the
 * `presentation` property. The element never discovers calculator state from
 * Datastar, global variables, attributes, or the DOM.
 */
export class FishyPresentationRenderElement extends HTMLElementBase {
    constructor() {
        super();
        this._presentation = null;
        this._paintFrameId = 0;
        this._paintResizeObserver = null;
    }

    connectedCallback() {
        if (
            this._paintResizeObserver === null
            && typeof globalThis.ResizeObserver === "function"
        ) {
            this._paintResizeObserver = new globalThis.ResizeObserver(() => {
                this.schedulePaint();
            });
            this._paintResizeObserver.observe(this);
        }
        this.schedulePaint();
    }

    disconnectedCallback() {
        this._paintResizeObserver?.disconnect();
        this._paintResizeObserver = null;
        if (this._paintFrameId && typeof globalThis.cancelAnimationFrame === "function") {
            globalThis.cancelAnimationFrame(this._paintFrameId);
        }
        this._paintFrameId = 0;
    }

    attributeChangedCallback(_name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.schedulePaint();
        }
    }

    get presentation() {
        return this._presentation;
    }

    set presentation(value) {
        this._presentation = value === null || value === undefined
            ? null
            : this.parsePresentation(value);
        this.schedulePaint();
    }

    parsePresentation(value) {
        return value;
    }

    schedulePaint() {
        if (!this.isConnected) {
            return;
        }
        if (this._paintFrameId) {
            return;
        }
        if (typeof globalThis.requestAnimationFrame !== "function") {
            this.paintPresentation();
            return;
        }
        this._paintFrameId = globalThis.requestAnimationFrame(() => {
            this._paintFrameId = 0;
            this.paintPresentation();
        });
    }

    paintPresentation() {
        if (!isElementPaintVisible(this)) {
            return;
        }
        this.renderPresentation(this._presentation);
    }

    replaceRenderedChildren(...nodes) {
        this.replaceChildren(...nodes);
    }

    renderPresentation(_presentation) {
        throw new Error("renderPresentation must be implemented by subclasses");
    }
}
